import getVisibilityStatus from './visibility-status';
import getRegisteredGroups from './registered-groups';
import getMenu from './menu';

export default {
  getVisibilityStatus,
  getRegisteredGroups,
  getMenu,
};
